import { render, staticRenderFns } from "./ViewBankDetails.vue?vue&type=template&id=b4ffe8d8&scoped=true&"
import script from "./ViewBankDetails.vue?vue&type=script&lang=js&"
export * from "./ViewBankDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewBankDetails.vue?vue&type=style&index=0&id=b4ffe8d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ffe8d8",
  null
  
)

export default component.exports